import axios from "axios";
import { API_BASE_URL, GET_LIST_MENU, FETCH_FAQS, GET_TIMER } from "../constants";

export const doGetListMenu = params => ({
  type: GET_LIST_MENU,
  payload: axios.get(`${API_BASE_URL}/menus`, params).then(res => res.data)
});

export const fetchFaqs = () => ({
  type: FETCH_FAQS,
  payload: axios.get(`${API_BASE_URL}/faqs`).then(res => res.data)
});

export const getTimer = () => ({
  type: GET_TIMER,
  payload: axios.get(`${API_BASE_URL}/timer`).then(res => res.data)
})

export const doScrollSection = name => ({
  type: "SCROLL_SECTION_FAQ",
  payload: name
});

export const setCountDownModal = (params) => ({
  type: "COUNTDOWN_MODAL",
  payload: params
})

export const setTimer = (data: any) => ({
  type: "SET_TIMER",
  payload: data
})